import * as React from 'react';
import {FunctionComponent} from 'react';
import {Bucket} from '../../../../Utils/Bucket';

interface OwnProps {
    buckets: Array<{
        value: {formatted: string; unit?: string};
        label: string;
    }>;
}

export const TopRow: FunctionComponent<OwnProps> = ({buckets}) => {
    return (
        <>
            {buckets.map((bucket, index) => (
                <Bucket key={index} small blue value={bucket.value} label={bucket.label} />
            ))}
        </>
    );
};
